<div class="load-tracking-map" [class.details-opened]="!!selectedTrip">
    <div class="load-tracking-map-middle">
        <div class="load-tracking-map-middle-container" [class._hasTimeline]="!singleTrip && selectedTrip && selectedTrip.timelineParamsInitialized">
            <div class="map-container">

                <agm-map [latitude]="lat"
                         [longitude]="lng"
                         [zoom]="zoom"
                         [styles]="mapStyles"
                         [disableDoubleClickZoom]="true"
                         [disableDefaultUI]="true"
                         (mapReady)="onMapReady($event)">
                    <agm-zoom-control></agm-zoom-control>
                    <agm-fullscreen-control [position]="'BOTTOM_RIGHT'"></agm-fullscreen-control>

                    <!-- Displaying selected trip details-->
                    <agm-marker-spider *ngIf="selectedTrip && selectedTrip.timelineParamsInitialized"
                                       [keepSpiderfied]="true"
                                       [nearbyDistance]="50"
                                       [ignoreMapClick]="true"
                                       [circleSpiralSwitchover]="7"
                                       [circleStartAngle]="45"
                                       [circleFootSeparation]="75"
                                       [spiralLengthStart]="15"
                                       [spiralLengthFactor]="1.5"
                                       [spiralFootSeparation]="30">

                        <!-- Displaying timeline truck cursor -->
                        <agm-marker *ngIf="!singleTrip && truckCursorPosition && !selectedTrip.isPlanned()"
                                    [zIndex]="10"
                                    [latitude]="truckCursorPosition.latitude"
                                    [longitude]="truckCursorPosition.longitude"
                                    [iconUrl]="activeTrailerIconUrl">
                            <agm-info-window>
                                <div class="content">
                                    <div class="title" [ngStyle]="{'color': '#0078bf'}">Truck position</div>
                                    <div>from timeline cursor</div>
                                </div>
                            </agm-info-window>
                        </agm-marker>

                        <!-- Displaying single trip current position Truck marker-->
                        <agm-marker class="test-marker" *ngIf="selectedTrip.latestPing"
                                    [zIndex]="5"
                                    [latitude]="selectedTrip.latestPing.latitude"
                                    [longitude]="selectedTrip.latestPing.longitude"
                                    [iconUrl]="passiveTrailerIconUrl">
                            <agm-info-window>
                                <div class="content">
                                    <div class="title" [ngStyle]="{'color': '#0078bf'}" [i18n]="'realtime-tracking.common.last-ping'"></div>
                                    <div class="time" [title]="lastPingFormat ? lastPingDuration : lastPingDate">{{lastPingFormat ? lastPingDate : lastPingDuration}}</div>
                                </div>
                            </agm-info-window>
                        </agm-marker>

                        <!-- Displaying origin of selected trip -->
                        <agm-marker *ngIf="!singleTrip"
                                    [zIndex]="100"
                                    [latitude]="selectedTrip.originPosition.lat"
                                    [longitude]="selectedTrip.originPosition.lng"
                                    [iconUrl]="selectedTrip.originLocationType === 'CHEP' ? chepDepartureIconUrl : customerDepartureIconUrl">
                            <agm-info-window>
                                <div class="content">
                                    <div class="main-address" [ngStyle]="{'color': '#0078bf'}">{{selectedTrip.originAddress}}</div>
                                    <div class="complement-address">{{selectedTrip.originCity+' '+selectedTrip.originPostalCode}}</div>
                                    <div class="country">{{selectedTrip.originCountryCode}}</div>
                                </div>
                            </agm-info-window>
                        </agm-marker>

                        <!-- Displaying destination of selected trip -->
                        <agm-marker [zIndex]="100"
                                    [latitude]="selectedTrip.destPosition.lat"
                                    [longitude]="selectedTrip.destPosition.lng"
                                    [iconUrl]="selectedTrip.destLocationType === 'CHEP' ? chepArrivalIconUrl : customerArrivalIconUrl">
                            <agm-info-window>
                                <div class="content">
                                    <div class="main-address" [ngStyle]="{'color': '#0078bf'}">{{selectedTrip.destAddress}}</div>
                                    <div class="complement-address">{{selectedTrip.destCity+' '+selectedTrip.destPostalCode}}</div>
                                    <div class="country">{{selectedTrip.destCountryCode}}</div>
                                </div>
                            </agm-info-window>
                        </agm-marker>

                        <!-- Displaying load handovers of selected trip-->
                        <ng-container *ngFor="let handover of selectedTrip.loadHandovers">
                            <agm-marker *ngIf="handover.releasedLatitude != null  && handover.releasedLongitude != null
                                    && (handover.distanceBetweenReleaseAndTake == null || handover.distanceBetweenReleaseAndTake > 50)"
                                        [zIndex]="1"
                                        [latitude]="handover.releasedLatitude"
                                        [longitude]="handover.releasedLongitude"
                                        [iconUrl]="handoverReleaseIconUrl">
                                <agm-info-window>
                                    <div class="content">
                                        <div class="title" [ngStyle]="{'color': '#0078bf'}" [i18n]="'realtime-tracking.common.load-handover.handover'"></div>
                                        <div [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.common.load-handover.@released', params: {releasedAt: handover.releasedAt | date, vehicle: handover.releasedByVehicle}}]"></div>
                                    </div>
                                </agm-info-window>
                            </agm-marker>
                            <agm-marker *ngIf="handover.takenLatitude != null  && handover.takenLongitude != null &&
                                    (handover.distanceBetweenReleaseAndTake == null || handover.distanceBetweenReleaseAndTake > 50)"
                                        [zIndex]="1"
                                        [latitude]="handover.takenLatitude"
                                        [longitude]="handover.takenLongitude"
                                        [iconUrl]="handoverTakeIconUrl">
                                <agm-info-window>
                                    <div class="content">
                                        <div class="title" [ngStyle]="{'color': '#0078bf'}" [i18n]="'realtime-tracking.common.load-handover.handover'"></div>
                                        <div [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.common.load-handover.@taken', params: {takenAt: handover.takenAt | date, vehicle: handover.takenByVehicle}}]"></div>
                                    </div>
                                </agm-info-window>
                            </agm-marker>
                            <agm-marker *ngIf="(handover.takenLatitude != null  && handover.takenLongitude != null)
                                    && (handover.releasedLatitude != null  && handover.releasedLongitude != null)
                                    && (handover.distanceBetweenReleaseAndTake != null && handover.distanceBetweenReleaseAndTake <= 50)"
                                        [zIndex]="1"
                                        [latitude]="handover.takenLatitude"
                                        [longitude]="handover.takenLongitude"
                                        [iconUrl]="handoverReleaseTakeIconUrl">
                                <agm-info-window>
                                    <div class="content">
                                        <div class="title" [ngStyle]="{'color': '#0078bf'}" [i18n]="'realtime-tracking.common.load-handover.handover'"></div>
                                        <div [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.common.load-handover.@released', params: {releasedAt: handover.releasedAt | date, vehicle: handover.releasedByVehicle}}]"></div>
                                        <div [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.common.load-handover.@taken', params: {takenAt: handover.takenAt | date, vehicle: handover.takenByVehicle}}]"></div>
                                    </div>
                                </agm-info-window>
                            </agm-marker>
                        </ng-container>
                    </agm-marker-spider>

                    <!-- Displaying bucket trips current position-->
                    <agm-marker-cluster *ngIf="!selectedTrip && !singleTrip"
                                        [gridSize]="30"
                                        [styles]="clusterStyle"
                                        [minimumClusterSize]="2"
                                        [maxZoom]="18"
                                        [zoomOnClick]="true"
                                        [averageCenter]="true">
                        <agm-marker-spider [keepSpiderfied]="true"
                                           [nearbyDistance]="10"
                                           [ignoreMapClick]="true"
                                           [circleSpiralSwitchover]="6"
                                           [circleStartAngle]="45"
                                           [circleFootSeparation]="75"
                                           [spiralLengthStart]="75"
                                           [spiralLengthFactor]="3"
                                           [spiralFootSeparation]="50">
                            <ng-container *ngFor="let trip of bucketTrips">
                                <agm-marker *ngIf="trip.latestPing && !trip.isCompleted() && !trip.isExpired()"
                                            [latitude]="trip.latestPing.latitude"
                                            [longitude]="trip.latestPing.longitude"
                                            (markerClick)="selectTrip(trip)"
                                            [iconUrl]="passiveTrailerIconUrl"
                                            [agmFitBounds]="true">
                                    <agm-info-window [isOpen]="trip === selectedTrip">
                                        <span>{{trip.latestPing.createdAt | dateDiffFromNow | async}}</span>
                                    </agm-info-window>
                                </agm-marker>
                            </ng-container>
                        </agm-marker-spider>
                    </agm-marker-cluster>

                    <!-- Displaying achieved path -->
                    <ng-container *ngIf="showAchievedPath && selectedTrip">
                        <ng-container *ngFor="let devicePaths of selectedTrip.achievedPaths; let deviceI = index">
                            <ng-container *ngIf="devicePaths.displayed">
                                <ng-container *ngFor="let path of devicePaths.paths">
                                    <ng-container *ngIf="path.displayed">
                                        <agm-polyline [zIndex]="5"
                                                      [strokeColor]="passiveColors[deviceI % passiveColors.length]"
                                                      [strokeWeight]="5"
                                                      [strokeOpacity]=".8">
                                            <agm-polyline-point *ngFor="let ping of path.pings"
                                                                [latitude]="ping.latitude"
                                                                [longitude]="ping.longitude">
                                            </agm-polyline-point>
                                            <!--                            <agm-polyline-point *ngIf="path.pings.length === 1" [latitude]="path.pings[0].latitude" [longitude]="path.pings[0].longitude"></agm-polyline-point>-->
                                            <agm-icon-sequence [offset]="'30px'"
                                                               [repeat]="'100px'"
                                                               [scale]="3"
                                                               [strokeColor]="'#6bbcee'"
                                                               [path]="'FORWARD_CLOSED_ARROW'">
                                            </agm-icon-sequence>
                                        </agm-polyline>

                                        <ng-container *ngIf="path.nextPath">
                                            <agm-polyline [zIndex]="5"
                                                          [strokeColor]="'#000000'"
                                                          [strokeWeight]="2"
                                                          [strokeOpacity]="0">
                                                <agm-polyline-point [latitude]="path.lastPing.latitude"
                                                                    [longitude]="path.lastPing.longitude">
                                                </agm-polyline-point>
                                                <agm-polyline-point [latitude]="path.nextPath.firstPing.latitude"
                                                                    [longitude]="path.nextPath.firstPing.longitude">
                                                </agm-polyline-point>
                                                <agm-icon-sequence [path]="'M 0,-1 0,1'"
                                                                   [strokeOpacity]="0.3"
                                                                   [repeat]="'20px'"
                                                                   [offset]="'0'">
                                                </agm-icon-sequence>
                                            </agm-polyline>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <!-- Dispalying forecast path -->
                    <agm-polyline *ngIf="showForecastPath && selectedTrip && forecastPathReady"
                                  [zIndex]="5"
                                  [strokeColor]="passiveColors[0]"
                                  [strokeWeight]="5"
                                  [strokeOpacity]=".4">
                        <agm-polyline-point *ngFor="let p of selectedTrip.forecastPath"
                                            [latitude]="p.lat"
                                            [longitude]="p.lng">
                        </agm-polyline-point>
                        <agm-icon-sequence [offset]="'30px'"
                                           [repeat]="'100px'"
                                           [scale]="3"
                                           [strokeOpacity]=".8"
                                           [strokeColor]="'#0078BF'"
                                           [path]="'FORWARD_CLOSED_ARROW'">
                        </agm-icon-sequence>
                    </agm-polyline>
                </agm-map>

                <div class="trips-map-settings-all">
                    <div class="trips-map-settings-left">
                        <div class="trips-map-setting bucket-switcher" *ngIf="!showBucket && !singleTrip" (click)="showBucketChange.emit(true)">
                            <i class="fas fa-filter fa-2x"></i>
                            <i class="fas fa-chevron-right fa-x"></i>
                        </div>
                        <div class="trips-map-setting mode-switcher text-right" *ngIf="!singleTrip" (click)="switchMode()">
                            <i class="fas fa-list"></i>
                            <div [i18n]="'realtime-tracking.load-tracking-map.options.overview'"></div>
                        </div>
                    </div>

                    <div class="trips-map-settings-right">
                        <div class="trips-map-setting achieved-path-setting text-right" *ngIf="!singleTrip">
                            <label class="dspl-block">
                                <input type="checkbox" [(ngModel)]="showAchievedPath" (ngModelChange)="showAchievedPathChange.emit(showAchievedPath)">
                                <i class="fa checkbox-icon" [ngClass]="[showAchievedPath ? 'checked' : 'unchecked']"></i>
                                <span [i18n]="'realtime-tracking.load-tracking-map.options.show-achieved-route'"></span>
                            </label>
                        </div>
                        <div class="trips-map-setting forecast-path-setting text-right" *ngIf="(selectedTrip && selectedTrip.status !== TripStatus.COMPLETED && selectedTrip.status !== TripStatus.EXPIRED) || (!selectedTrip && !singleTrip)">
                            <label class="dspl-block">
                                <input type="checkbox" [(ngModel)]="showForecastPath" (ngModelChange)="showForecastPathChange.emit(showForecastPath)">
                                <i class="fa checkbox-icon" [ngClass]="[showForecastPath ? 'checked' : 'unchecked']"></i>
                                <span [i18n]="'realtime-tracking.load-tracking-map.options.show-forecast-route'"></span>
                            </label>
                        </div>

                        <div class="trips-map-settings text-right">
                            <app-dropdown-button [btnTextKey]="'realtime-tracking.load-tracking-map.options.title'" [btnIconClass]="'fa fa-cogs'">
                                <li app-dropdown-button-item [hasCheckbox]="true" *ngIf="!singleTrip">
                                    <label class="dspl-block">
                                        <input type="checkbox" [(ngModel)]="excludeIsolatedPings" (change)="refreshEmitter.emit()">
                                        <i class="fa checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.load-tracking-map.options.exclude-isolated-pings'"></span>
                                    </label>
                                </li>
                                <li app-dropdown-button-item [hasCheckbox]="true" *ngIf="!singleTrip">
                                    <label class="dspl-block">
                                        <input type="checkbox" [(ngModel)]="hidePingsAfterDestinationHit" (change)="refreshEmitter.emit()">
                                        <i class="fa checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.load-tracking-map.options.hide-pings-after-destination-hit'"></span>
                                    </label>
                                </li>
                                <li app-dropdown-button-item [hasCheckbox]="true" *ngIf="canShowDebug">
                                    <label class="dspl-block">
                                        <input type="checkbox" [(ngModel)]="debug">
                                        <i class="fa checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.load-tracking-map.options.debug'"></span>
                                    </label>
                                </li>
                                <li app-dropdown-button-item [hasCheckbox]="true" *ngIf="canShowDebug">
                                    <label class="dspl-block">
                                        <input type="checkbox" [(ngModel)]="keepPingsWithHighAccuracy" (change)="refreshEmitter.emit()">
                                        <i class="fa checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.load-tracking-map.options.keep-pings-with-poor-accuracy'"></span>
                                    </label>
                                </li>
                                <li app-dropdown-button-item [hasCheckbox]="true" *ngIf="!singleTrip" [titleKey]="selectedTrip && !selectedTrip.timezone ?'realtime-tracking.load-tracking-map.options.trip-timezone-not-available' : ''">
                                    <label class="dspl-block">
                                        <input type="checkbox" [(ngModel)]="displayDatesInTripTimezone" [disabled]="selectedTrip && !selectedTrip.timezone" (change)="displayDatesInTripTimezoneChange()">
                                        <i class="fa checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.load-tracking-map.options.display-dates-in-trip-timezone'"></span>
                                    </label>
                                </li>
                                <li app-dropdown-button-item>
                        <span>
                            <span [i18n]="'realtime-tracking.load-tracking-map.options.distance-unit'"></span>
                            <select class="form-control distance-unit-select" [(ngModel)]="distanceUnit">
                                <option [ngValue]="DistanceUnit.MILES" [i18n]="'distance-unit.miles'"></option>
                                <option [ngValue]="DistanceUnit.KILOMETERS" [i18n]="'distance-unit.kilometers'"></option>
                            </select>
                        </span>
                                </li>
                            </app-dropdown-button>
                        </div>
                    </div>
                </div>

                <div class="map-zoom-center-setting" *ngIf="selectedTrip" (click)="centerView()">
                    <i class="fas fa-bullseye fa-x"></i><span [i18n]="'realtime-tracking.load-tracking-map.options.center'"></span>
                </div>

                <div class="trips-map-close-details" *ngIf="selectedTrip" (click)="switchDetails()">
                    <i class="fa fa-chevron-right"></i>
                </div>
            </div>

            <app-load-tracking-trip-details *ngIf="selectedTrip && selectedTrip.timelineParamsInitialized"
                                            [ngStyle]="{
                                        'transform': showDetail ? 'translateX(0)' : 'translateX(100%)',
                                        'position': showDetail ? 'static' : 'absolute'
                                        }"
                                            [(trip)]="selectedTrip"
                                            [singleTrip]="singleTrip"
                                            [debug]="debug"
                                            [distanceUnit]="distanceUnit"
                                            (onRefresh)="forceRefreshTripDetails()"
                                            (onUpdateLoadHandover)="updateLatLngLiteral($event)"
                                            (onGoToMarker)="goToMarker($event)">
            </app-load-tracking-trip-details>
        </div>

        <app-trip-timeline *ngIf="!singleTrip && selectedTrip && selectedTrip.timelineParamsInitialized"
                           [(trip)]="selectedTrip"
                           [distanceUnit]="distanceUnit"
                           [refreshing]="refreshing"
                           (onRefresh)="forceRefreshTripDetails()"
                           (truckMoved)="updateTruckCursor($event)">
        </app-trip-timeline>
    </div>
</div>
